export const [minCharacterCount, maxCharacterCount] = [8, 16];
